import type { ColorValue } from 'react-native';

import { Svg, SvgPath, SvgProps } from '../../../components/svg';

const DEFAULT_FILL = '#502314';

export function OpenInNew(props: SvgProps) {
  const fill: ColorValue = typeof props.color === 'string' ? props.color : DEFAULT_FILL;

  return (
    <Svg {...props} width="15" height="14" viewBox="0 0 15 14" fill="none">
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.04688 3.75C2.86039 3.75 2.68155 3.81585 2.54969 3.93306C2.41783 4.05027 2.34375 4.20924 2.34375 4.375V10.625C2.34375 10.7908 2.41783 10.9497 2.54969 11.0669C2.68155 11.1842 2.86039 11.25 3.04688 11.25H10.0781C10.1705 11.25 10.2619 11.2338 10.3472 11.2024C10.4325 11.171 10.51 11.125 10.5753 11.0669C10.6406 11.0089 10.6924 10.94 10.7277 10.8642C10.7631 10.7883 10.7812 10.7071 10.7812 10.625V5.83333C10.7812 5.60322 10.9911 5.41667 11.25 5.41667C11.5089 5.41667 11.7188 5.60322 11.7188 5.83333V10.625C11.7188 10.8165 11.6763 11.0061 11.5939 11.1831C11.5114 11.36 11.3906 11.5208 11.2382 11.6562C11.0859 11.7916 10.905 11.899 10.706 11.9723C10.5069 12.0456 10.2936 12.0833 10.0781 12.0833H3.04688C2.61175 12.0833 2.19445 11.9297 1.88678 11.6562C1.5791 11.3827 1.40625 11.0118 1.40625 10.625V4.375C1.40625 3.98823 1.5791 3.61729 1.88678 3.3438C2.19445 3.07031 2.61175 2.91667 3.04688 2.91667H7.95352C8.2124 2.91667 8.42227 3.10321 8.42227 3.33333C8.42227 3.56345 8.2124 3.75 7.95352 3.75H3.04688Z"
        fill={fill}
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.375 1.66667C9.375 1.43655 9.58487 1.25 9.84375 1.25H13.125C13.3839 1.25 13.5938 1.43655 13.5938 1.66667V4.58333C13.5938 4.81345 13.3839 5 13.125 5C12.8661 5 12.6562 4.81345 12.6562 4.58333V2.08333H9.84375C9.58487 2.08333 9.375 1.89679 9.375 1.66667Z"
        fill={fill}
      />
      <SvgPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2221 1.58037C13.4051 1.74309 13.4051 2.00691 13.2221 2.16963L6.89396 7.79463C6.7109 7.95735 6.4141 7.95735 6.23104 7.79463C6.04799 7.63191 6.04799 7.36809 6.23104 7.20537L12.5592 1.58037C12.7422 1.41765 13.039 1.41765 13.2221 1.58037Z"
        fill={fill}
      />
    </Svg>
  );
}
